export const techCategories = {
    // ВЕБ-РАЗРАБОТКА
    backend: [
        { icon: 'logos:python', name: 'Python' },
        { icon: 'logos:java', name: 'Java' },
        { icon: 'logos:go', name: 'Go' },
        { icon: 'logos:ruby', name: 'Ruby' },
        { icon: 'logos:rust', name: 'Rust' },
        { icon: 'logos:c-plusplus', name: 'C++' },
        { icon: 'logos:c-sharp', name: 'C#' },
        { icon: 'logos:nestjs', name: 'NestJS' },
        { icon: 'logos:php', name: 'PHP' },
        { icon: 'logos:nodejs-icon', name: 'Node.js' },
        { icon: 'logos:django-icon', name: 'Django' },
        { icon: 'logos:flask', name: 'Flask' },
        { icon: 'logos:express', name: 'Express' },
        { icon: 'logos:spring-icon', name: 'Spring' },
        { icon: 'logos:fastapi', name: 'FastAPI' },
    ],
    frontend: [
        { icon: 'logos:javascript', name: 'JavaScript' },
        { icon: 'logos:typescript-icon', name: 'TypeScript' },
        { icon: 'logos:react', name: 'React' },
        { icon: 'logos:angular-icon', name: 'Angular' },
        { icon: 'logos:nextjs-icon', name: 'Next.js' },
        { icon: 'logos:vue', name: 'Vue.js' },
        { icon: 'logos:svelte-icon', name: 'Svelte' },
        { icon: 'logos:nuxt-icon', name: 'Nuxt.js' },
        { icon: 'logos:remix', name: 'Remix' },
        { icon: 'logos:tailwindcss-icon', name: 'Tailwind CSS' },
        { icon: 'logos:css-3', name: 'CSS3' },
        { icon: 'logos:html-5', name: 'HTML5' },
    ],

    // МОБИЛЬНЫЕ ПРИЛОЖЕНИЯ
    mobile: [
        { icon: 'logos:swift', name: 'Swift' },
        { icon: 'logos:kotlin-icon', name: 'Kotlin' },
        { icon: 'logos:react', name: 'React Native' },
        { icon: 'logos:flutter', name: 'Flutter' },
        { icon: 'logos:android-icon', name: 'Android' },
        { icon: 'logos:apple-ios', name: 'iOS' },
        { icon: 'logos:ionic-icon', name: 'Ionic' },
        { icon: 'logos:xamarin', name: 'Xamarin' },
    ],

    // ДЕСКТОПНЫЕ ПРИЛОЖЕНИЯ
    desktop: [
        { icon: 'logos:electron', name: 'Electron' },
        { icon: 'logos:python', name: 'Python (PyQt/PySide)' },
        { icon: 'logos:c-sharp', name: 'C# (WPF/WinForms)' },
        { icon: 'logos:java', name: 'Java (JavaFX/Swing)' },
        { icon: 'logos:rust', name: 'Rust (Tauri)' },
        { icon: 'logos:go', name: 'Go (Fyne)' },
        { icon: 'logos:cpp', name: 'C++ (Qt)' },
        { icon: 'logos:fltk', name: 'FLTK' },
    ],

    // ОБЛАКО И DevOps
    cloud: [
        { icon: 'logos:aws', name: 'AWS' },
        { icon: 'logos:microsoft-azure', name: 'Azure' },
        { icon: 'logos:google-cloud', name: 'Google Cloud' },
        { icon: 'logos:docker', name: 'Docker' },
        { icon: 'logos:kubernetes', name: 'Kubernetes' },
        { icon: 'logos:terraform', name: 'Terraform' },
        { icon: 'logos:ansible', name: 'Ansible' },
        { icon: 'logos:jenkins', name: 'Jenkins' },
        { icon: 'logos:gitlab', name: 'GitLab CI/CD' },
        { icon: 'logos:github-actions', name: 'GitHub Actions' },
        { icon: 'logos:prometheus', name: 'Prometheus' },
        { icon: 'logos:grafana', name: 'Grafana' },
        { icon: 'logos:helm', name: 'Helm' },
    ],

    // БАЗЫ ДАННЫХ
    databases: [
        { icon: 'logos:postgresql', name: 'PostgreSQL' },
        { icon: 'logos:mysql', name: 'MySQL' },
        { icon: 'logos:mongodb-icon', name: 'MongoDB' },
        { icon: 'logos:redis', name: 'Redis' },
        { icon: 'logos:elasticsearch', name: 'Elasticsearch' },
        { icon: 'logos:sqlite', name: 'SQLite' },
        { icon: 'logos:microsoft-sql-server', name: 'SQL Server' },
        { icon: 'logos:oracle', name: 'Oracle' },
        { icon: 'logos:cassandra', name: 'Cassandra' },
        { icon: 'logos:influxdb', name: 'InfluxDB' },
        { icon: 'logos:clickhouse', name: 'ClickHouse' },
        { icon: 'logos:prisma', name: 'Prisma ORM' },
        { icon: 'logos:sequelize', name: 'Sequelize' },
        { icon: 'logos:typeorm', name: 'TypeORM' },
    ],

    // АНАЛИТИКА ДАННЫХ И BIG DATA
    analytics: [
        { icon: 'logos:apache-spark', name: 'Apache Spark' },
        { icon: 'logos:hadoop', name: 'Hadoop' },
        { icon: 'logos:kafka', name: 'Apache Kafka' },
        { icon: 'logos:airflow', name: 'Apache Airflow' },
        { icon: 'logos:dbt', name: 'dbt' },
        { icon: 'logos:snowflake', name: 'Snowflake' },
        { icon: 'logos:tableau', name: 'Tableau' },
        { icon: 'logos:power-bi', name: 'Power BI' },
        { icon: 'logos:looker', name: 'Looker' },
        { icon: 'logos:apache-flink', name: 'Apache Flink' },
        { icon: 'logos:presto', name: 'Presto' },
        { icon: 'logos:databricks', name: 'Databricks' },
    ],

    // ИИ И МАШИННОЕ ОБУЧЕНИЕ
    ai_ml: [
        { icon: 'logos:tensorflow', name: 'TensorFlow' },
        { icon: 'logos:pytorch', name: 'PyTorch' },
        { icon: 'logos:scikit-learn', name: 'Scikit-learn' },
        { icon: 'logos:keras', name: 'Keras' },
        { icon: 'logos:huggingface', name: 'Hugging Face' },
        { icon: 'logos:openai', name: 'OpenAI API' },
        { icon: 'logos:langchain', name: 'LangChain' },
        { icon: 'logos:anthropic', name: 'Anthropic Claude' },
        { icon: 'logos:cohere', name: 'Cohere' },
        { icon: 'logos:opencv', name: 'OpenCV' },
        { icon: 'logos:nltk', name: 'NLTK' },
        { icon: 'logos:spacy', name: 'spaCy' },
        { icon: 'logos:pandas', name: 'Pandas' },
        { icon: 'logos:numpy', name: 'NumPy' },
        { icon: 'logos:jax', name: 'JAX' },
        { icon: 'logos:mlflow', name: 'MLflow' },
        { icon: 'logos:weights-biases', name: 'Weights & Biases' },
    ],

    // IoT-РЕШЕНИЯ
    iot: [
        { icon: 'logos:arduino', name: 'Arduino' },
        { icon: 'logos:raspberry-pi', name: 'Raspberry Pi' },
        { icon: 'logos:mqtt', name: 'MQTT' },
        { icon: 'logos:influxdb', name: 'InfluxDB' },
        { icon: 'logos:grafana', name: 'Grafana' },
        { icon: 'logos:aws-iot', name: 'AWS IoT' },
        { icon: 'logos:azure-iot', name: 'Azure IoT' },
        { icon: 'logos:google-iot', name: 'Google IoT Core' },
        { icon: 'logos:home-assistant', name: 'Home Assistant' },
        { icon: 'logos:node-red', name: 'Node-RED' },
        { icon: 'logos:zigbee', name: 'Zigbee' },
        { icon: 'logos:lorawan', name: 'LoRaWAN' },
    ],

    // БЛОКЧЕЙН И WEB3
    blockchain: [
        { icon: 'logos:ethereum', name: 'Ethereum' },
        { icon: 'logos:solidity', name: 'Solidity' },
        { icon: 'logos:bitcoin', name: 'Bitcoin' },
        { icon: 'logos:polkadot', name: 'Polkadot' },
        { icon: 'logos:solana', name: 'Solana' },
        { icon: 'logos:web3js', name: 'Web3.js' },
        { icon: 'logos:ethers', name: 'Ethers.js' },
        { icon: 'logos:hardhat', name: 'Hardhat' },
        { icon: 'logos:truffle', name: 'Truffle' },
    ],

    // БЕЗОПАСНОСТЬ
    security: [
        { icon: 'logos:owasp', name: 'OWASP' },
        { icon: 'logos:burp-suite', name: 'Burp Suite' },
        { icon: 'logos:metasploit', name: 'Metasploit' },
        { icon: 'logos:wireshark', name: 'Wireshark' },
        { icon: 'logos:sonarqube', name: 'SonarQube' },
        { icon: 'logos:hashicorp-vault', name: 'HashiCorp Vault' },
        { icon: 'logos:letsencrypt', name: 'Let\'s Encrypt' },
    ],
};
